import { Component, Input, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeUrlPipeModule } from '../../pipes/safe-url.pipe';
import { OeAppService } from '../../shared/oe-app.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';

@Component({
  selector: 'lp2-share-certificate-iframe',
  template: `
    <iframe *ngIf="shareCertificateUrl"
    [src]="shareCertificateUrl | safeUrl"
    frameborder="0"
    class="share-iframe">
  </iframe>
  `,
  styleUrls: ['./share-certificate-iframe.component.scss'],
})
export class ShareCertificateIframeComponent implements OnInit {
  @Input() certificateLevel: number;
  shareCertificateUrl: string;

  constructor(private oeApp: OeAppService, private oeAppPersonService: OeAppPersonService) { }

  ngOnInit() {
    const environment = this.oeApp.environment;
    const contactId = this.oeAppPersonService.contactId;

    if (environment && contactId && this.certificateLevel) {
      this.shareCertificateUrl = 
      this.oeApp.webShareCertificatePageHost +
      '?env=' + environment +
      '&contactId=' + contactId +
      '&level=' + this.certificateLevel +
      '&lang=' + this.oeAppPersonService.preferredLang;
    };
  }

}

@NgModule({
  imports: [
    CommonModule, SafeUrlPipeModule
  ],
  declarations: [ShareCertificateIframeComponent],
  exports: [ShareCertificateIframeComponent],
})
export class ShareCertificateIframeModule { }



// WEBPACK FOOTER //
// ./ts/app/components/share-certificate-iframe/share-certificate-iframe.component.ts